<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
      >
       <CRHeader :headerData="this.headerData"/>
      </div>
      <div class="md-layout-item md-size-100 p-0 mt-4">
        <md-card class="if_card report-tab">
          <md-card-header class="md-card-header-icon">
            SWOT Analysis
          </md-card-header>
          <md-card-content>
            <div class="md-layout p-4" v-if="companyReport">
              <div
                class="md-layout-item md-medium-size-100 md-size-100"
                v-for="category in this.categories"
                :key="category"
              >
                <md-card class="md-card-profile">
                  <md-card-header>
                    <h4 class="title m-0">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                      >
                        {{ category }}
                      </div>
                    </h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="extra_space">
                      <ul>
                        <li
                          v-for="item in getDataByCategory(category)"
                          :key="item.title"
                        >
                          {{ item.title }}:
                          <p :style="item.red ? 'color: red' : ''">
                            {{ item.text }}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import CRHeader from './CRHeader.vue';

export default {
  components: { 
    CRHeader,
  },
  props:['headerData'],
  data() {
    return {
      categories: []
    };
  },
  mounted(){
    this.categories = this.getCategories();
  },
  computed: {
    user(){
      return this.$store.state.user.user;
    },
    companyReport() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportSummary() {
      return this.$store.getters.companyReportSummary;
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },    
  },
  methods: {
    getDataByCategory(category) {
      let titleTextList = [];      
      Object.values(this.companyReport.dynamic_text).map((array) => {
        array.map((object) =>
          object.category === category ? titleTextList.push(object) : ''
        );
      });

      return titleTextList;
    },
    getCategories(){   
 
      if (this.companyReportSummary) {
        let categories = [];

        Object.values(this.companyReport.dynamic_text).map((array) => {
          array.map((object) =>
            categories.includes(object.category)
              ? ''
              : categories.push(object.category)
          );
        });
        return categories;
      } else {
        return [];
      }
    },
    
  },
};
</script>

<style lang="scss">
.company-report-pdf {
  display: flex;
  justify-content: flex-end;
}

.summary-scores-box-star {
  .md-button-content {
    .md-icon {
      color: #3b7ef1;
    }
  }
}
</style>
